import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { fifthAnalysesActions } from 'features/fifthAnalyses';

const useFifthAnalyses = () => {
  const dispatch = useDispatch();
  const getFifthAnalyses = useCallback(({ offset }) => dispatch(fifthAnalysesActions.getFifthAnalyses({ offset })), [dispatch]);
  const getFifthAnalysis = useCallback(({ id, cable }) => dispatch(fifthAnalysesActions.getFifthAnalysis({ id, cable })), [dispatch]);
  const clearLocalFifthAnalyses = useCallback(() => dispatch(fifthAnalysesActions.clearLocalFifthAnalyses()), [dispatch]);
  const clearLocalActiveFifthAnalysis = useCallback(() => dispatch(fifthAnalysesActions.clearLocalActiveFifthAnalysis()), [dispatch]);

  return {
    getFifthAnalyses,
    getFifthAnalysis,
    clearLocalFifthAnalyses,
    clearLocalActiveFifthAnalysis
  };
};

export default useFifthAnalyses;